export const SLASH_UNWRAPPED_PATTERN = '\\\\\\/';
export const SLASH_PATTERN = '[' + SLASH_UNWRAPPED_PATTERN + ']';
export const SLASH_REGEXP = new RegExp(SLASH_PATTERN);
export const WINDOWS_DRIVE_LETTER_PATTERN = '(?:[a-zA-Z]:)';
export const WINDOWS_DRIVE_LETTER_REGEXP = new RegExp('^(' + WINDOWS_DRIVE_LETTER_PATTERN + ')(' + SLASH_PATTERN + '|$)');
export const WINDOWS_NETWORK_PATTERN = '(?:\\\\\\\\[^' + SLASH_UNWRAPPED_PATTERN + ']+)';
export const WINDOWS_NETWORK_REGEXP = new RegExp('^(' + WINDOWS_NETWORK_PATTERN + ')(' + SLASH_PATTERN + '|$)');
export const WINDOWS_ROOT_PATTERN = '(?:' + WINDOWS_DRIVE_LETTER_PATTERN + '|' + WINDOWS_NETWORK_PATTERN + ')';
export const WINDOWS_ROOT_REGEXP = new RegExp('^(' + WINDOWS_ROOT_PATTERN + ')(' + SLASH_PATTERN + '|$)');
export const WINDOWS_SEPARATOR = '\\';
export const WINDOWS_DELIMITER_PATTERN = ';';
export const WINDOWS_DELIMITER_REGEXP = new RegExp(WINDOWS_DELIMITER_PATTERN);
export const WINDOWS_CONFIG = Object.freeze({
    driveLetterPattern: WINDOWS_DRIVE_LETTER_PATTERN,
    driveLetterRegEx: WINDOWS_DRIVE_LETTER_REGEXP,
    networkPattern: WINDOWS_NETWORK_PATTERN,
    networkRegEx: WINDOWS_NETWORK_REGEXP,
    rootPattern: WINDOWS_ROOT_PATTERN,
    rootRegExp: WINDOWS_ROOT_REGEXP,
    separator: WINDOWS_SEPARATOR,
    delimiterPattern: WINDOWS_DELIMITER_PATTERN,
    delimiterRegExp: WINDOWS_DELIMITER_REGEXP,
});
export const WINDOWS_STRICT_CONFIG = Object.freeze({
    ...WINDOWS_CONFIG,
    rootPattern: WINDOWS_DRIVE_LETTER_PATTERN,
    rootRegExp: WINDOWS_DRIVE_LETTER_REGEXP,
});
export const POSIX_ROOT_PATTERN = '';
export const POSIX_ROOT_REGEXP = new RegExp('^(' + POSIX_ROOT_PATTERN + ')(' + SLASH_PATTERN + '|$)');
export const POSIX_SEPARATOR = '/';
export const POSIX_DELIMITER_PATTERN = ':';
export const POSIX_DELIMITER_REGEXP = new RegExp(POSIX_DELIMITER_PATTERN);
export const POSIX_CONFIG = Object.freeze({
    rootPattern: POSIX_ROOT_PATTERN,
    rootRegExp: POSIX_ROOT_REGEXP,
    separator: POSIX_SEPARATOR,
    delimiterPattern: POSIX_DELIMITER_PATTERN,
    delimiterRegExp: POSIX_DELIMITER_REGEXP,
});
export const ROOT_PATTERN = '(?:' + WINDOWS_ROOT_PATTERN + '|' + POSIX_ROOT_PATTERN + ')';
export const ROOT_REGEXP = new RegExp('^(' + ROOT_PATTERN + ')(' + SLASH_PATTERN + '|$)');
export const DELIMITER_PATTERN = '(?:' + WINDOWS_DELIMITER_PATTERN + '|' + POSIX_DELIMITER_PATTERN + ')';
export const DELIMITER_REGEXP = new RegExp('(' + DELIMITER_PATTERN + ')');
export const GENERIC_CONFIG = Object.freeze({
    rootPattern: ROOT_PATTERN,
    rootRegExp: ROOT_REGEXP,
    separator: POSIX_SEPARATOR,
    delimiterPattern: DELIMITER_PATTERN,
    delimiterRegExp: DELIMITER_REGEXP,
});
//# sourceMappingURL=configs.js.map